<div id="nav-primary" class="primary-nav-container">
  <ul class="list-inline">
    <li>
      @if (isEpi && !isAuthenticated) {
        <a id="headerHomeLink" rdxAnalytics="header home link" [href]="homeUrl">
          <svg-icon class="primary-nav-icon" src="/assets/icons/home.svg" alt="home" i18n-alt />
          <div i18n>Home</div>
        </a>
      }
      @if (!isEpi || (isEpi && isAuthenticated)) {
        <a
          id="headerHomeLink"
          href="javascript:void(0)"
          routerLink="/home"
          routerLinkActive="active"
          rdxAnalytics="header home link"
        >
          <svg-icon class="primary-nav-icon" src="/assets/icons/home.svg" alt="home" i18n-alt />
          <div i18n>Home</div>
        </a>
      }
    </li>
    <li>
      <a
        id="headerMapLink"
        href="javascript:void(0)"
        routerLink="/map"
        routerLinkActive="active"
        rdxAnalytics="header map link"
      >
        <svg-icon class="primary-nav-icon" src="/assets/icons/map.svg" alt="map" i18n-alt />
        <div i18n>Map</div>
      </a>
    </li>
    <li>
      <a
        id="headerRidesLink"
        href="javascript:void(0)"
        routerLink="/rides"
        routerLinkActive="active"
        rdxAnalytics="header rides-places link"
      >
        <svg-icon class="primary-nav-icon" src="/assets/icons/routes.svg" alt="rides/places" i18n-alt />
        <div i18n>Rides/Places</div>
      </a>
    </li>
    <li>
      <a
        id="headerCommunityLink"
        href="javascript:void(0)"
        routerLink="/community"
        routerLinkActive="active"
        rdxAnalytics="header community link"
      >
        <svg-icon class="primary-nav-icon" src="/assets/icons/community.svg" alt="community" i18n-alt />
        <div i18n>Community</div>
      </a>
    </li>
    <li>
      @if (isEpi && !isAuthenticated) {
        <a id="headerMaintenanceLink" rdxAnalytics="header garage link" [href]="loggedOutGarageUrl">
          <div i18n>Garage</div>
        </a>
      }

      @if (!isEpi || (isEpi && isAuthenticated)) {
        <a
          id="headerMaintenanceLink"
          href="javascript:void(0)"
          routerLink="/maintenance"
          routerLinkActive="active"
          rdxAnalytics="header garage link"
        >
          @if (brand === 'offroad' && (isMapTypeSno$ | async) === false) {
            <svg-icon class="primary-nav-icon" src="/assets/icons/orv.svg" alt="garage" i18n-alt />
          }
          @if (brand === 'offroad' && (isMapTypeSno$ | async)) {
            <svg-icon class="primary-nav-icon" src="/assets/icons/snow.svg" alt="garage" i18n-alt />
          }
          @if (brand === 'indian') {
            <svg-icon class="primary-nav-icon" src="/assets/icons/bike.svg" alt="garage" i18n-alt />
          }
          @if (brand === 'slingshot') {
            <svg-icon class="primary-nav-icon" src="/assets/icons/slingshot.svg" alt="garage" i18n-alt />
          }
          <div i18n>Garage</div>
        </a>
      }
    </li>
    @if (brand === 'offroad' || brand === 'indian') {
      <li>
        <a
          id="headerRideCommandPlusLink"
          rdxAnalytics="header ride command plus helper-link"
          [href]="rideCommandPlusUrl"
        >
          <svg-icon class="primary-nav-icon" src="/assets/icons/plus.svg" alt="ride-command-plus" i18n-alt />
          <div i18n>RIDE COMMAND+</div>
        </a>
      </li>
    }
  </ul>
</div>
